import { GetterTree } from "vuex";
import { RootState, ReservationState } from "@/interface";
import { isSystemCourseGetter } from "./getter-types";

export const getters: GetterTree<ReservationState, RootState> = {
  [isSystemCourseGetter]: (state: ReservationState): boolean => {
    return Boolean(
      state.courseInfo && state.courseInfo.course_type === "系统课"
    );
  }
};
